export const actionOnStepper = {avanti:0, indietro:1}